import {
  Alert,
  Confirm,
  NewUser,
  OrganizationForm,
  RoundedTab,
  RoundedTabGroup,
  SearchOrgUser,
  InvoiceList,
  InvoiceDialog,
} from "@mikros/shared-ui";
import { Button } from "@progress/kendo-react-buttons";
import React, { useEffect, useState } from "react";

import { OrganizationDetails } from "@mikros/library";
import ApiServices from "../../service/apiService";
import { useNavigate } from "react-router-dom";
import { Dialog } from "@progress/kendo-react-dialogs";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router";
import ErrorHandler from "../../utils/errorConfig";
import S3Service from "../../service/s3Service";
import { toast } from "react-hot-toast";

export function Customer() {
  const navigate = useNavigate();
  const params = useParams();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [showNewUser, setShowNewUser] = useState(false);
  const [showSearchUser, setShowSearchUser] = useState(true);
  const [formDialog, setformDialog] = React.useState<boolean>(false);
  const [formUserDialog, setFormUserDialog] = React.useState<boolean>(false);
  const [customerData, setCustomerData] = React.useState<any>();
  const [showDialogtext, setShowDialogtext] = React.useState<any>(true);
  const [showAdminDialogtext, setAdminDialogtext] = React.useState<any>(true);
  const [showAdminuserTab, setAdminuserTab] = React.useState<boolean>(true);
  const [adminUserData, setadminUserData] = useState<any>();
  const [userId, setUserId] = useState<any>();
  const [formType, setFormType] = useState<boolean>(false);
  const [newFormOrg, setNewFormOrg] = useState<boolean>(false);
  const [orgId, setOrgId] = useState<any>();

  const [logoDestinationFilePath, setLogoDestinationFilePath] =
    useState<string>("");
  const [signature1DestinationFilePath, setSignature1DestinationFilePath] =
    useState<string>("");
  const [signature2DestinationFilePath, setSignature2DestinationFilePath] =
    useState<string>("");

  const [allOrgData, setAllOrgData] = useState<any>();

  // Invoice state
  const [invoiceDialogOpen, setInvoiceDialogOpen] = useState<boolean>(false);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const [invoicesList, setInvoicesList] = useState<any[]>([]);
  const [loadingInvoices, setLoadingInvoices] = useState<boolean>(false);

  const [shouldTriggerNewUser, setShouldTriggerNewUser] = useState(false);

  // const [showOrganizationForm, setShowOrganizationForm] = useState(true);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  console.log("customer data in customer dashboard state", customerData);
  console.log("new form org", newFormOrg);
  console.log("show new user", showNewUser);
  console.log("show admin user tab", showAdminuserTab);
  console.log("org id", orgId);

  console.log("params print", params);
  console.log("show admin user tab", showAdminuserTab);

  console.log("show new user value", showNewUser);

  const intl = useIntl();

  var [gridData, setGridData] = useState({
    fname: "",
    lname: "",
    mnum: "",
    email: "",
    role: "",
    status: "",
  });
  console.log("grid data set", gridData);
  var flag = 0;

  const analyticsValues: { [key: string]: boolean } = {
    Enabled: true,
    Disabled: false,
  };

  const certificationValues: { [key: string]: boolean } = {
    Enabled: true,
    Disabled: false,
  };
  const auditValues: { [key: string]: boolean } = {
    Enabled: true,
    Disabled: false,
  };

  useEffect(() => {
    console.log(params);
    if (params?.id) {
      let api = ApiServices.getInstance();
      api
        .makeRequest(`organization/${params?.id}`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("inside get of organization");

          data.whatAccessToken = data?.distbAcc?.whatsApp?.accTkn;
          data.whatsapp = data?.distbAcc?.whatsApp?.enabled;
          data.teams = data?.distbAcc?.teams?.enabled;
          data.teamAccessToken = data?.distbAcc?.teams?.accTkn;
          data.slack = data?.distbAcc?.slack?.enabled;
          data.slackAccessToken = data?.distbAcc?.slack?.accTkn;
          data.emailCheck = data?.distbAcc?.email?.enabled;
          data.emailAccessToken = data?.distbAcc?.email?.accTkn;
          let a = new Date(data?.validUpTo).toString();
          data.validUpTo = a || "";
          data.aiModel = data?.aiModel;
          data.analytics = data?.analytics;
          setOrgId(params?.id);

          console.log(data, "print cust data in customer dashboard");
          setCustomerData(data);
          setAdminuserTab(true);
        });

      api
        .makeRequest(`organization/${params?.id}/customersadmin`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          setOrgId(params?.id);
          console.log(data);
          setadminUserData(data);
          setAdminuserTab(true);
        });
    } else {
      setShowSearchUser(false);
      setAdminuserTab(false);
    }
  }, [gridData]);

  const handleGridItemClick = (data: any) => {
    console.log("gridDta", data?.dataItem?.userId);
    setUserId(data?.dataItem?.userId);
    setGridData(data);
    setShowSearchUser(false);
    setFormType(true);
    console.log("rec data in parent", data);
    flag = 1;
  };

  const toggleformDialog = () => {
    setformDialog(!formDialog);
  };

  const toggleformUserDialog = () => {
    setFormUserDialog(!formUserDialog);
  };

  const initialGridData = {
    fname: "",
    lname: "",
    mnum: "",
    email: "",
    role: "",
    status: "",
  };

  function getCustomerAdmin() {
    if (formType === false) {
      navigate("/createCustomer/" + orgId);
    }
    console.log("params.id", params?.id);
    let api = ApiServices.getInstance();
    api
      .makeRequest(`organization/${orgId}/customersadmin`, "GET")
      .then(async (data) => {
        if (data && data.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        }
        console.log(data);
        setadminUserData(data);
        setAdminuserTab(true);
      });
  }

  const fetchInvoices = () => {
    if (!params?.id) return;
    setLoadingInvoices(true);
    let api = ApiServices.getInstance();
    api
      .makeRequest(`organization/${params.id}/invoice`, "GET")
      .then(async (res) => {
        setLoadingInvoices(false);
        if (res && res.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        // API response: { success, count, invoices }
        if (res?.invoices && Array.isArray(res.invoices)) {
          setInvoicesList(res.invoices);
        } else if (Array.isArray(res)) {
          setInvoicesList(res);
        } else {
          setInvoicesList([]);
        }
      })
      .catch((err) => {
        setLoadingInvoices(false);
        console.error("Error fetching invoices", err);
      });
  };

  const handleInvoiceItemClick = (invoice: any) => {
    setSelectedInvoice(invoice);
    setInvoiceDialogOpen(true);
  };

  function resetTabs(tabName: string) {
    setShowNewUser(false);
    setShowSearchUser(true);
    setGridData(initialGridData);
    if (tabName === "Invoices") {
      fetchInvoices();
    }
  }

  const handleNewUserClick = () => {
    console.log("I am inside handle new user click");
    setShowNewUser(true);
    setShowSearchUser(false);
    setFormType(false);
  };

  const handleCreateNewFromOrg = () => {
    // navigate("/createCustomer/");
    // getAllOrganization();
    getCustomerAdmin();
    setNewFormOrg(true);
    setShowNewUser(true);
    setShowSearchUser(false);
    setFormType(false);
    setAdminuserTab(true);
  };

  const removeFileFromS3 = async (
    accntId: string,
    folder: string,
    newFileName: string
  ) => {
    console.log(
      "print the accnt id, folder, new file name  in remove file",
      accntId,
      folder,
      newFileName
    );
    let s3 = S3Service.getInstance();
    await s3
      .removeFile(`acct-${accntId}/${folder}/${newFileName}`, "Cust-Info")
      .then(() => console.log("Old file deleted success"));
  };

  const uploadFileToS3 = (
    e: any,
    accntId: string,
    folder: string,
    existingFileName: string
  ) =>
    new Promise<object>((resolve, reject) => {
      // let destFilePath = `acct-${accntId}/${folder}/${e?.target?.name}`;
      let destFilePath = `Cust-Info/acct-${accntId}/${folder}/${e?.target?.name}`;
      console.log("print event received", e);
      const reader = new FileReader();
      let s3 = S3Service.getInstance();
      const newFileName = e?.target?.name;

      const filePathToPass = destFilePath.replace(/^Cust-Info\//, "");

      reader.readAsDataURL(e?.target);
      reader.onload = async () => {
        let file = s3.convertToFile(
          reader.result,
          e?.target?.type,
          e?.target?.name
        );
        console.log("File formed", file);
        console.log("existing file name print", existingFileName);
        console.log("new file name print", newFileName);
        console.log("destination file path", destFilePath);

        console.log("Target type", e?.target?.type);
        console.log("File print", file);
        console.log("Destination file path", destFilePath);

        console.log("File path to pass", filePathToPass);
        console.log("File content to pass", file);

        // Set the destination file path based on the folder type
        if (folder === "logo") {
          setLogoDestinationFilePath(destFilePath);
        } else if (folder === "signature1") {
          setSignature1DestinationFilePath(destFilePath);
        } else if (folder === "signature2") {
          setSignature2DestinationFilePath(destFilePath);
        }

        if (existingFileName && existingFileName !== newFileName) {
          console.log("Deleting old file:", existingFileName);
          await s3
            .removeFile(
              `acct-${accntId}/${folder}/${existingFileName}`,
              "Cust-Info"
            )
            .then(() => console.log("Old file deleted success"))
            .catch((error) => console.error("deleting old file error", error));
        }

        await s3
          // .writeFileInFolder(destFilePath, file, "Cust-Info", e?.target?.type)
          .writeFileInFolder(filePathToPass, file, "Cust-Info", e?.target?.type)
          .then(async (res) => {
            console.log("Response is", res);
          });

        return destFilePath;
      };
    });

  function getOrganizationFormData(data: any) {
    console.log("admin organization data", data);
    console.log("certification details", data?.certification);
    if (params?.id) {
      let body: OrganizationDetails = {
        dateCreated: customerData?.dateCreated,
        organizationName: data?.orgName,
        address: {
          add1: data.addrLine1,
          add2: data.addrLine2,
          city: data.city,
          state: data.state,
          country: data.country,
          zipcode: data.zipCode,
        },
        email: data?.email,
        phNo: data?.userProfile?.phNo,
        legalName: data?.legalName,
        distbAcc: {
          whatsApp: {
            enabled: data?.whatsapp ? true : false,
            accTkn: data.whatAccessToken ? data.whatAccessToken : "",
          },
          teams: {
            enabled: data.teams ? true : false,
            accTkn: data.teamAccessToken ? data.teamAccessToken : "",
            azureId: "",
          },
          slack: {
            enabled: data.slack ? true : false,
            accTkn: data.slackAccessToken ? data.slackAccessToken : "",
          },
          email: {
            enabled: data.emailCheck ? true : false,
            accTkn: data.emailAccessToken ? data.emailAccessToken : "",
          },
        },
        validUpTo: data.validUpTo || "",
        status: data.status,
        aiModel: data.aiModel,
        analytics: data?.analytics ? true : false,
        accntId: data.accntId,
        createdAt: 0,
        // logo: data.logo || "",
        logo: logoDestinationFilePath || data.logo,
        lowerEmail: data.lowerEmail,
        lowerLegalName: data.lowerLegalName,
        lowerOrgName: data.lowerOrgName,
        updatedAt: 0,
        featureAccess: {
          audit: data?.featureAccess?.audit ? true : false,
          certification: data?.featureAccess?.certification ? true : false,
          certification_details: {
            sign1: {
              signerName:
                data?.featureAccess?.certification_details?.sign1?.signerName,
              signerRole:
                data?.featureAccess?.certification_details?.sign1?.signerRole,
              signUrl:
                // data?.featureAccess?.certification_details?.sign1?.signUrl,

                signature1DestinationFilePath ||
                data?.featureAccess?.certification_details?.sign1?.signUrl,
            },
            sign2: {
              signerName:
                data?.featureAccess?.certification_details?.sign2?.signerName,
              signerRole:
                data?.featureAccess?.certification_details?.sign2?.signerRole,
              signUrl:
                // data?.featureAccess?.certification_details?.sign2?.signUrl,
                signature2DestinationFilePath ||
                data?.featureAccess?.certification_details?.sign2?.signUrl,
            },
          },
        },
        // Pricing configuration
        pricingConfig: data?.pricingConfig ? {
          pricePerTotalUser: Number(data.pricingConfig.pricePerTotalUser) || 0,
          pricePerActiveUser: Number(data.pricingConfig.pricePerActiveUser) || 0,
          pricePerCardToActive: Number(data.pricingConfig.pricePerCardToActive) || 0,
          discountPercent: Number(data.pricingConfig.discountPercent) || 0,
        } : undefined,
      };

      console.log(body, "body for post update request");

      let api = ApiServices.getInstance();
      api
        .makeRequest(`organization/${params?.id}`, "POST", body)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log(res);
          setShowDialogtext(false);

          toggleformDialog();
        });
    } else {
      let body: OrganizationDetails = {
        dateCreated: new Date().getTime(),
        organizationName: data.orgName,
        address: {
          add1: data.addrLine1,
          add2: data.addrLine2,
          city: data.city,
          state: data.state,
          country: data.country,
          zipcode: data.zipCode,
        },
        email: data.email,
        phNo: data.userProfile.phNo,
        legalName: data.legalName,
        distbAcc: {
          whatsApp: {
            enabled: data.whatsapp ? true : false,
            accTkn: data.whatAccessToken ? data.whatAccessToken : "",
          },
          teams: {
            enabled: data.teams ? true : false,
            accTkn: data.teamAccessToken ? data.teamAccessToken : "",
            azureId: "",
          },
          slack: {
            enabled: data.slack ? true : false,
            accTkn: data.slackAccessToken ? data.slackAccessToken : "",
          },
          email: {
            enabled: data.emailCheck ? true : false,
            accTkn: data.emailAccessToken ? data.emailAccessToken : "",
          },
        },
        validUpTo: data.validUpTo,
        status: data.status,
        aiModel: data.aiModel,
        analytics: data?.analytics ? true : false,
        accntId: data.accntId,
        createdAt: 0,
        logo: data.logo || "",
        lowerEmail: data?.lowerEmail,
        lowerLegalName: data?.lowerLegalName,
        lowerOrgName: data?.lowerOrgName,
        updatedAt: 0,
        // Pricing configuration for new organization
        pricingConfig: data?.pricingConfig ? {
          pricePerTotalUser: Number(data.pricingConfig.pricePerTotalUser) || 0,
          pricePerActiveUser: Number(data.pricingConfig.pricePerActiveUser) || 0,
          pricePerCardToActive: Number(data.pricingConfig.pricePerCardToActive) || 0,
          discountPercent: Number(data.pricingConfig.discountPercent) || 0,
        } : undefined,
      };
      console.log("body for post request", body);
      let api = ApiServices.getInstance();
      api.makeRequest("organization", "POST", body).then(async (res) => {
        if (res && res.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        console.log(res, "data1 organization customer dashboard details");
        setOrgId(res?.orgData?.accntId);
        setShowDialogtext(true);
        toggleformDialog();
      });
    }
  }

  const handleGenerateInvoice = (invoicePayload: {
    type: string;
    year: number;
    month: number;
    fromTime: number;
    tillTime: number;
  }) => {
    if (!invoicePayload || !params?.id) return;
    const body = {
      accntId: params.id,
      option: invoicePayload.type,
      fromTime: invoicePayload.fromTime,
      tillTime: invoicePayload.tillTime,
    };
    let api = ApiServices.getInstance();
    api
      .makeRequest(`organization/${params.id}/invoice`, "POST", body)
      .then(async (res) => {
        console.log("invoice generation response", res);
        if (res && res.errorMessage) {
          // Show error in UI using the same pattern as other errors
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        if (res) {
          // Use API response directly - it now contains all required fields:
          // invoiceType, billedUsers, billAmount, discountAmount, finalBillAmount,
          // invoiceNo, invoiceDate, fromDate, toDate, existingInvoice
          setSelectedInvoice(res);
          setInvoiceDialogOpen(true);
        }
      })
      .catch(async (err) => {
        console.error("invoice generation error", err);
        setErrorFlag(true);
        await errorInstance.updateErrorCode(err?.message || "INVOICE_GENERATION_FAILED");
      });
  };

  const formatCurrency = (value?: number) => {
    if (value === undefined || value === null || isNaN(Number(value))) {
      return "-";
    }
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (dateValue?: any) => {
    if (!dateValue) return "-";
    // If already formatted string
    if (typeof dateValue === "string" && /[a-zA-Z]/.test(dateValue)) {
      return dateValue;
    }
    // Handle epoch timestamp or numeric string
    let timestamp = dateValue;
    if (typeof dateValue === "string") {
      // Try parsing as ISO date first
      const isoDate = new Date(dateValue);
      if (!isNaN(isoDate.getTime())) {
        const day = isoDate.getDate().toString().padStart(2, "0");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[isoDate.getMonth()];
        const year = isoDate.getFullYear();
        return `${day}-${month}-${year}`;
      }
      timestamp = Number(dateValue);
    }
    if (typeof timestamp === "number" && !isNaN(timestamp)) {
      const ms = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
      const date = new Date(ms);
      if (!isNaN(date.getTime())) {
        const day = date.getDate().toString().padStart(2, "0");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
    }
    return String(dateValue);
  };

  const handleStatusUpdate = async (entityId: string, recType: string, status: string): Promise<void> => {
    try {
      const api = ApiServices.getInstance();
      const body = { entityId, recType, status };
      
      const res = await api.makeRequest(`organization/${params.id}/invoice/status`, "POST", body);
      
      if (res && res.errorMessage) {
        toast.error(`Failed to update status: ${res.errorMessage}`);
        throw new Error(res.errorMessage);
      }
      
      if (res && res.success) {
        toast.success("Invoice status updated successfully!");
        // Update the selected invoice with new status
        setSelectedInvoice((prev: any) => ({ ...prev, status }));
        // Refresh invoices list
        fetchInvoices();
      }
    } catch (error: any) {
      console.error("Error updating invoice status:", error);
      toast.error(error?.message || "Failed to update invoice status");
      throw error;
    }
  };

  function submitAdminUser(data1: any) {
    console.log("I am inside submit admin user");
    if (userId) {
      console.log("submit admin user while update", data1);
      data1.userId = userId;
      let api = ApiServices.getInstance();

      api
        .makeRequest(`organization/${params?.id}/customersadmin`, "POST", data1)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log(res);
          setAdminDialogtext(false);
          toggleformUserDialog();
        });
    } else {
      data1.userId = "";
      let api = ApiServices.getInstance();
      api
        .makeRequest(`organization/${params?.id}/customersadmin`, "POST", data1)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log(res);
          setAdminDialogtext(true);
          toggleformUserDialog();
        });
    }
  }

  function phNoFunction() {}

  function saveDialogFunction() {}
  function saveDialog() {}
  function newUserState() {}

  // function setFormType1() {}

  // Step 1: Build tabs array dynamically
  const tabs = [
    {
      name: "Org",
      title: intl.formatMessage({ id: "organizationTab" }),
      content: (
        <>
          <OrganizationForm
            getOrganizationFormData={getOrganizationFormData}
            customerData={customerData}
            formType={showAdminuserTab ? "EDIT" : "NEW"}
            uploadFileToS3={uploadFileToS3}
            removeFileFromS3={removeFileFromS3}
            pageType={"admin"}
            onGenerateInvoice={handleGenerateInvoice}
          />

          {formDialog && (
            <Dialog className="confirmSuccessDialogue">
              <Confirm
                description={
                  showDialogtext
                    ? intl.formatMessage({
                        id: "createCustomer.Successmessage",
                      })
                    : intl.formatMessage({
                        id: "createCustomer.SuccessUpdatemessage",
                      })
                }
                successText={intl.formatMessage({ id: "users.buttonText.Ok" })}
                failureText={intl.formatMessage({
                  id: "customerDashboard.createAdminMessage",
                })}
                icon={"/successShape.png"}
                iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
                backgroundColor={"mk-bright-green"}
                onSuccess={() => {
                  toggleformDialog();
                  navigate("/customer");
                }}
                onFailure={() => {
                  toggleformDialog();
                  handleCreateNewFromOrg();
                  setTimeout(() => {
                    const tabButtons = document.querySelectorAll("button");
                    const adminUserTab = Array.from(tabButtons).find((btn) =>
                      btn.textContent?.includes("Admin Users")
                    );
                    adminUserTab?.click();
                  }, 300);
                }}
              />
            </Dialog>
          )}
        </>
      ),
    },
  ];

  // If admin user data is present, add AdminUser tab
  // if (showAdminuserTab && adminUserData && adminUserData.length > 0) {
  if (showAdminuserTab) {
    tabs.push({
      name: "AdminUser",
      title: intl.formatMessage({ id: "organization.adminUsers" }),
      content: (
        <>
          <div className="w-full flex justify-end items-center mt-[-2.25rem] right-12 top-20">
            {showSearchUser && (
              <Button
                className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                onClick={handleNewUserClick}
              >
                <FormattedMessage id="organization.newUserButton" />
              </Button>
            )}
          </div>

          <div className="mb-10" />

          {showSearchUser && (
            <SearchOrgUser
              searchUserState={setShowSearchUser}
              newUserState={setShowNewUser}
              adminUserData={adminUserData}
              formTypeFunction={setFormType}
              dataGridItemFunction={handleGridItemClick}
            />
          )}

          {showNewUser && (
            <NewUser
              submitAdminUser={submitAdminUser}
              newUserState={newUserState}
              formTypeFunction={setFormType}
              adminUserState={setAdminuserTab}
              phNo={""}
              saveDialogFunction={saveDialogFunction}
              saveDialog={saveDialog}
              phNoFunction={phNoFunction}
              dataGridItem={gridData}
              formType={formType ? "EDIT" : "NEW"}
            />
          )}

          {formUserDialog && (
            <Dialog className="confirmSuccessDialogue">
              <Alert
                description={
                  showAdminDialogtext
                    ? intl.formatMessage({
                        id: "createAdmin.SuccessCreatemessage",
                      })
                    : intl.formatMessage({
                        id: "createAdmin.SuccessUpdatemessage",
                      })
                }
                buttonText={intl.formatMessage({ id: "createCustomer.Ok" })}
                icon={"/successShape.png"}
                iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
                backgroundColor={"mk-bright-green"}
                onClick={() => {
                  toggleformUserDialog();
                  setTimeout(() => {
                    const tabButtons = document.querySelectorAll("button");
                    const adminUserTab = Array.from(tabButtons).find((btn) =>
                      btn.textContent?.includes("Admin Users")
                    );
                    adminUserTab?.click();
                  }, 100);
                }}
              />
            </Dialog>
          )}
        </>
      ),
    });
  }

  // Add Invoices tab (always shown when viewing an existing customer)
  if (params?.id) {
    tabs.push({
      name: "Invoices",
      title: intl.formatMessage({ id: "organization.invoicesTab" }),
      content: (
        <div className="pb-[10%] pt-4">
          <InvoiceList
            invoices={invoicesList}
            loading={loadingInvoices}
            onInvoiceClick={handleInvoiceItemClick}
            onRefresh={fetchInvoices}
            organizationName={customerData?.organizationName}
            hideInvoiceType={false}
          />
        </div>
      ),
    });
  }

  return (
    <>
      <div className="flex">
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"/errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
                // navigate("/customer");
              }}
            />
          </Dialog>
        )}
        {/* <RoundedTabGroup
        className="w-full"
        defaultTabName="Org"
        onClick={resetTabs}
      >
        <RoundedTab
          name="Org"
          title={intl.formatMessage({ id: "organizationTab" })}
        >
          <OrganizationForm
              getOrganizationFormData={getOrganizationFormData}
              customerData={customerData}
              formType={showAdminuserTab ? "EDIT" : "NEW"}
              uploadFileToS3={uploadFileToS3}
              removeFileFromS3={removeFileFromS3}
            />

          {formDialog && (
            <Dialog className="confirmSuccessDialogue">
              <Confirm
                description={
                  showDialogtext
                    ? `${intl.formatMessage({
                        id: "createCustomer.Successmessage",
                      })}`
                    : `${intl.formatMessage({
                        id: "createCustomer.SuccessUpdatemessage",
                      })}`
                }
                successText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                failureText={intl.formatMessage({
                  id: "customerDashboard.createAdminMessage",
                })}
                icon={"/successShape.png"}
                iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
                backgroundColor={"mk-bright-green"}
                onSuccess={() => {
                  toggleformDialog();
                  navigate("/customer");
                }}
                onFailure={() => {
                  toggleformDialog();
                  handleCreateNewFromOrg();

                  //  Wait a moment for DOM to update
                  setTimeout(() => {
                    const tabButtons = document.querySelectorAll("button");
                    const adminUserTab = Array.from(tabButtons).find(
                      (btn) => btn.textContent?.includes("Admin Users") // match your tab's label exactly
                    );

                    adminUserTab?.click(); //  simulate tab switch
                  }, 100); // short delay ensures tab buttons are rendered
                }}
              />
            </Dialog>
          )}
        </RoundedTab>

        {showAdminuserTab ? (
          <RoundedTab
            name="AdminUser"
            title={intl.formatMessage({ id: "organization.adminUsers" })}
          >
            {showAdminuserTab && (
              <div className="w-full flex justify-end items-center mt-[-2.25rem] right-12 top-20">
                {showSearchUser && showAdminuserTab && (
                  <Button
                    className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
           hover:text-black focus:outline-none px-4 py-2"
                    onClick={handleNewUserClick}
                  >

                    <FormattedMessage id="organization.newUserButton"></FormattedMessage>
                  </Button>
                )}
              </div>
            )}
            <div className="mb-10"></div>
            {showAdminuserTab && showSearchUser && (
              <SearchOrgUser
                searchUserState={setShowSearchUser}
                newUserState={setShowNewUser}
                adminUserData={adminUserData}
                formTypeFunction={setFormType}
                dataGridItemFunction={handleGridItemClick}
              />
            )}

            {showNewUser && showAdminuserTab && (
              <NewUser
                submitAdminUser={submitAdminUser}
                newUserState={newUserState}
                // formTypeFunction={setFormType1}
                formTypeFunction={setFormType}
                adminUserState={setAdminuserTab}
                phNo={""}
                saveDialogFunction={saveDialogFunction}
                saveDialog={saveDialog}
                phNoFunction={phNoFunction}
                dataGridItem={gridData}
                formType={formType ? "EDIT" : "NEW"}
              />
            )}

            {formUserDialog && (
              <Dialog className="confirmSuccessDialogue">
                <Alert
                  description={
                    showAdminDialogtext
                      ? `${intl.formatMessage({
                          id: "createAdmin.SuccessCreatemessage",
                        })}`
                      : `${intl.formatMessage({
                          id: "createAdmin.SuccessUpdatemessage",
                        })}`
                  }
                  buttonText={`${intl.formatMessage({
                    id: "createCustomer.Ok",
                  })}`}
                  icon={"/successShape.png"}
                  iconMsg={intl.formatMessage({
                    id: "iconMsgSuccess",
                  })}
                  backgroundColor={"mk-bright-green"}
                  onClick={() => {
                    toggleformUserDialog();
                    // navigate("/customer");

                    setTimeout(() => {
                      const tabButtons = document.querySelectorAll("button");
                      const adminUserTab = Array.from(tabButtons).find(
                        (btn) => btn.textContent?.includes("Admin Users") // match your tab's label exactly
                      );

                      adminUserTab?.click(); //  simulate tab switch
                    }, 100);
                  }}
                />
              </Dialog>
            )}
          </RoundedTab>
        ) : (
          <></>
          // <div></div>
        )}
      </RoundedTabGroup> */}

        <RoundedTabGroup
          className="w-full"
          defaultTabName="Org"
          onClick={resetTabs}
        >
          {tabs.map((tab) => (
            <RoundedTab key={tab.name} name={tab.name} title={tab.title}>
              {tab.content}
            </RoundedTab>
          ))}
        </RoundedTabGroup>
      </div>

      <InvoiceDialog
        open={invoiceDialogOpen}
        onClose={() => setInvoiceDialogOpen(false)}
        invoice={selectedInvoice}
        organizationName={customerData?.organizationName}
        organizationEmail={customerData?.email}
        organizationPhone={customerData?.phNo}
        onStatusUpdate={handleStatusUpdate}
        isAdmin={true}
      />
    </>
  );
}
